<template>
    <div v-if="visible" class="mt-3">
        <div class="accordion mb-3">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button :class="{'collapsed':!isOpen}" class="accordion-button bg-light fw-bold" type="button" @click="Open()">
                Size En Uygun Eğitim Paketi Seçelim!
              </button>
            </h2>
            <div :class="{'show':isOpen}" class="accordion-collapse collapse">
              <div class="accordion-body">
                <div class="row justify-content-md-center mt-3 mb-3">
                    <div class="col-sm-12 col-md-6 mb-3">
                        <div v-if="visiblePackageWeeklyDay2 || visiblePackageWeeklyDay3 || visiblePackageWeeklyDay5" class="text-center">
                          <div class="mb-2 fw-bold">Haftada kaç gün eğitim alabilirsiniz?</div>
                          <div class="btn-group btn-group-lg" role="group" aria-label="Basic radio toggle button group">
                            
                              <input v-if="visiblePackageWeeklyDay2" type="radio" class="btn-check" v-model="filterPackage.weeklyDay" v-bind:id="'weeklyDay2'" value="2">
                              <label v-if="visiblePackageWeeklyDay2" class="btn btn-outline-secondary" v-bind:for="'weeklyDay2'">2 Gün</label>

                              <input v-if="visiblePackageWeeklyDay3" type="radio" class="btn-check" v-model="filterPackage.weeklyDay" v-bind:id="'weeklyDay3'" value="3">
                              <label v-if="visiblePackageWeeklyDay3" class="btn btn-outline-secondary" v-bind:for="'weeklyDay3'">3 Gün</label>

                              <input v-if="visiblePackageWeeklyDay5" type="radio" class="btn-check" v-model="filterPackage.weeklyDay" v-bind:id="'weeklyDay5'" value="5">
                              <label v-if="visiblePackageWeeklyDay5" class="btn btn-outline-secondary" v-bind:for="'weeklyDay5'">5 Gün</label>
                          </div>
                        </div>

                        <div v-if="visiblePackageDuration20 || visiblePackageDuration30 || visiblePackageDuration40" class="mt-4 text-center">
                          <div class="mb-2 fw-bold">Günde kaç dakika eğitim görmek istersiniz?</div>
                          <div class="btn-group btn-group-lg" role="group" aria-label="Basic radio toggle button group">
                              <input v-if="visiblePackageDuration20" type="radio" class="btn-check" v-model="filterPackage.duration" v-bind:id="'duration20'" value="20">
                              <label v-if="visiblePackageDuration20" class="btn btn-outline-secondary" v-bind:for="'duration20'">20 Dakika</label>

                              <input v-if="visiblePackageDuration30" type="radio" class="btn-check" v-model="filterPackage.duration" v-bind:id="'duration30'" value="30">
                              <label v-if="visiblePackageDuration30" class="btn btn-outline-secondary" v-bind:for="'duration30'">30 Dakika</label>

                              <input v-if="visiblePackageDuration40" type="radio" class="btn-check" v-model="filterPackage.duration" v-bind:id="'duration40'" value="40">
                              <label v-if="visiblePackageDuration40" class="btn btn-outline-secondary" v-bind:for="'duration40'">40 Dakika</label>
                          </div>
                        </div>

                        <div v-if="visiblePackageMonth3 || visiblePackageMonth6 || visiblePackageMonth12" class="mt-4 text-center">
                          <div class="mb-2 fw-bold">Eğitime kaç ay devam etmek istersiniz?</div>
                          <div class="btn-group btn-group-lg" role="group" aria-label="Basic radio toggle button group">
                              <input v-if="visiblePackageMonth3" type="radio" class="btn-check" v-model="filterPackage.month" v-bind:id="'month3'" value="3">
                              <label v-if="visiblePackageMonth3" class="btn btn-outline-secondary" v-bind:for="'month3'">3 Ay</label>

                              <input v-if="visiblePackageMonth6" type="radio" class="btn-check" v-model="filterPackage.month" v-bind:id="'month6'" value="6">
                              <label v-if="visiblePackageMonth6" class="btn btn-outline-secondary" v-bind:for="'month6'">6 Ay</label>

                              <input v-if="visiblePackageMonth12" type="radio" class="btn-check" v-model="filterPackage.month" v-bind:id="'month12'" value="12">
                              <label v-if="visiblePackageMonth12" class="btn btn-outline-secondary" v-bind:for="'month12'">12 Ay</label>
                          </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <div v-if="packageLoading" class="text-center">
                          <div class="spinner-border">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="selectPackage!=null" class="card">
                            <div class="card-body">
                                <div class="text-end">Eğitim Paketi</div>
                                <div class="fw-bold text-end" v-html="selectPackage?.categoryTitle"></div>
                                <div class="fw-bold text-end mb-2" v-html="selectPackage?.packageTitle"></div>
                                <div class="text-end">Ayda Sadece</div>
                                <div class="fw-bold text-end fs-3">{{packageTotal}}₺</div>
                                <div class="text-end mb-2"><small>KDV dahildir</small></div>
                                <div class="border-top border-bottom pt-2 pb-2 mt-2 mb-2" style="font-size: small;">
                                <p>Toplam {{selectPackage?.packageProperty.lessonCount}} adet ders</p>
                                <span v-if="selectPackage?.packageProperty.postpone>0" class="d-block">{{selectPackage?.packageProperty.postpone}} adet ders ertele hakkı</span>
                                <span v-if="selectPackage?.packageProperty.freezeLesson" class="d-block">{{ selectPackage?.packageProperty.freezeLesson }} adet ders dondurma hakkı</span>
                                </div>
                                <a href="javascript:;" class="btn btn-primary btn-lg d-block" @click="$router.push({path:'/market/checkout',name:'MarketCheckoutPage',params:{id:selectPackage?.id,catid:CategoryId},query: { campaingcode: CampaingCode }})">Satın Al</a>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </template>
  <script>
import { setTimeout } from 'core-js';
import { mapActions } from "vuex";
  export default {
    name: "MarketSelectPackage",
    props: {
      CategoryId:{
        type:String,
        default:null
      },
      PackageId:{
        type:String,
        default:null
      },
      PackageMonth:{
        type:Array
      },
      PackageDuration:{
        type:Array
      },
      PackageWeeklyDay:{
        type:Array
      },
      CampaingCode:{
        type:String,
        default:null
      }
    },
    components: {
    },
    data() {
      return {
        packageLoading:false,
        selectPackage:null,
        filterPackage:{
          weeklyDay:2,
          duration:20,
          month:3
        },
        isOpen:false
      };
    },
    computed: {
        visible(){
            if(this.PackageId=='' && this.PackageMonth.length==0 && this.PackageDuration.length==0 && this.PackageWeeklyDay.length==0)
                return false;
            return true;
        },
        visiblePackageMonth12(){
          let find = this.PackageMonth.find(x=>x==12);
          if(find)
            return true;
          return false;
        },
        visiblePackageMonth6(){
          let find = this.PackageMonth.find(x=>x==6);
          if(find)
            return true;
          return false;
        },
        visiblePackageMonth3(){
          let find = this.PackageMonth.find(x=>x==3);
          if(find)
            return true;
          return false;
        },
        visiblePackageDuration20(){
          let find = this.PackageDuration.find(x=>x==20);
          if(find)
            return true;
          return false;
        },
        visiblePackageDuration30(){
          let find = this.PackageDuration.find(x=>x==30);
          if(find)
            return true;
          return false;
        },
        visiblePackageDuration40(){
          let find = this.PackageDuration.find(x=>x==40);
          if(find)
            return true;
          return false;
        },
        visiblePackageWeeklyDay2(){
          let find = this.PackageWeeklyDay.find(x=>x==2);
          if(find)
            return true;
          return false;
        },
        visiblePackageWeeklyDay3(){
          let find = this.PackageWeeklyDay.find(x=>x==3);
          if(find)
            return true;
          return false;
        },
        visiblePackageWeeklyDay5(){
          let find = this.PackageWeeklyDay.find(x=>x==5);
          if(find)
            return true;
          return false;
        },
        packageTotal(){
          let total = this.selectPackage?.prices[this.filterPackage.month-1].installmentPrice;
          return (total).toLocaleString('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
        }
    },
    methods: {
      ...mapActions(["FindPackageAsync"]),
      async getPackage(){
        this.packageLoading=true;
        await this.FindPackageAsync({
          categoryId:this.CategoryId,
          weeklyDay:this.filterPackage.weeklyDay.toString(),
          duration: this.filterPackage.duration.toString(),
          month: this.filterPackage.month.toString(),
          packageId: this.PackageId
        })
        .then((res)=>{
          this.selectPackage = res;
          this.packageLoading=false;
        })
        .catch(()=>{
          this.packageLoading=false
        });
      },
      Open(){
          this.isOpen = !this.isOpen;
      }
    },
    watch: {
      filterPackage: {
        handler() {
          if(this.filterPackage.month>0 || this.filterPackage.duration>0 || this.filterPackage.weeklyDay>0){
            this.getPackage();
          }
        },
        deep: true
      }
    },
    mounted:function(){
      let mainThis = this;
      mainThis.isOpen=false;
      setTimeout(function(){
        mainThis.filterPackage.month = (mainThis.visiblePackageMonth3 || mainThis.visiblePackageMonth9 || mainThis.visiblePackageMonth12)?3:0;
        mainThis.filterPackage.duration = (mainThis.visiblePackageDuration20 || mainThis.visiblePackageDuration30 || mainThis.visiblePackageDuration40)?20:0;
        mainThis.filterPackage.weeklyDay = (mainThis.visiblePackageWeeklyDay2 || mainThis.visiblePackageWeeklyDay3 || mainThis.visiblePackageWeeklyDay5)?2:0;
        if(mainThis.filterPackage.month>0 || mainThis.filterPackage.duration>0 || mainThis.filterPackage.weeklyDay>0){
          mainThis.getPackage();
        }
      },1000)
    }
   
  };
  </script>
  <style></style>